<template>
  <div class="about-us-dropdowns">
    <div class="container">
      <div
        class="dropdown-item"
        v-for="item in _.get(contentData, 'data.list')"
        :key="item.id"
        :class="{ open: selectedId == item.id }"
      >
        <div
          @click="toggle(item.id)"
          class="top pointer flex al-center between"
        >
          <div class="title bold uppercase">{{ item.title }}</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="7.857"
            viewBox="0 0 10 7.857"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(17.5 -12) rotate(90)"
              fill="#4d4d4f"
            />
          </svg>
        </div>
        <slide-up-down
          :active="selectedId == item.id"
          :duration="600"
          class="content"
        >
          <div class="content-container">
            <div class="title font-34 bold uppercase">
              {{ item.sub_title }}
            </div>
            <div class="text bold" v-html="item.content"></div>
            <div class="contact-row flex al-center">
              <a :href="'tel:' + item.teaser1" class="bold">{{
                item.teaser1
              }}</a>
              <a :href="'mailto:' + item.teaser2" class="bold">{{
                item.teaser2
              }}</a>
            </div>
          </div>
        </slide-up-down>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      selectedId: null
    };
  },
  methods: {
    toggle(id) {
      if (this.selectedId == id) {
        this.selectedId = null;
      } else {
        this.selectedId = id;
      }
    }
  }
};
</script>

<style lang="scss">
.about-us-dropdowns {
  background: #f7f7f7;
  padding-top: 55px;
  padding-bottom: 144px;
  @media (max-width: 1023px) {
    padding-bottom: 55px;
  }
  .dropdown-item {
    width: 100%;
    min-height: 60px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px;
    background: $white;
    flex-direction: column;
    margin-bottom: 30px;
    transition: 0.4s ease;
    .text a {
      color: $black;
      transition: 0.2s ease;

      &:hover {
        color: $red;
      }
    }
    &.open {
      background: #d1d1d1;
      .top {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .top {
      padding: 50px;
      @media (max-width: 1023px) {
        padding: 30px 30px 20px;
      }
      @media (max-width: 767px) {
        padding: 30px 20px 20px;
      }
      svg {
        transition: 0.4s ease;
      }
    }

    .content {
      background: $white;
      // padding: 50px;
      .content-container {
        padding: 50px;
        @media (max-width: 1023px) {
          padding: 34px 30px;
        }
        @media (max-width: 767px) {
          padding: 34px 20px;
        }
      }
      .text {
        margin: 12px 0 55px;
      }
      .contact-row {
        @media (max-width: 767px) {
          flex-direction: column;
          align-items: flex-start;
        }
        a {
          &:first-child {
            margin-right: 15px;
          }
          color: $black;
          &:first-child {
            @media (max-width: 767px) {
              margin-right: 0;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
